// Spinner component
import React from "react"
import tw, { styled } from "twin.macro"

export enum Sizes {
  Large = "large",
  Medium = "medium",
  Small = "small",
  ExtraSmall = "extrasmall",
}
export interface SpinnerProps {
  sizes?: Sizes
  color?: boolean
}

const Rotating = (color: SpinnerProps) => {
  const isPained = color ? "#7654EB" : "currentColor"
  return (
    <div tw="flex items-center justify-center">
      <div tw="rounded-t-xl overflow-hidden bg-gradient-to-r p-1">
        <div tw="flex justify-around">
          <div tw="inline-flex rounded-md shadow-sm">
            <svg tw="animate-spin h-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle tw="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path
                tw="opacity-75"
                fill={isPained}
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  )
}

export const StyledSpinner = styled("div")(({ sizes }: SpinnerProps) => [
  tw`
    w-12
    h-12
  `,
  sizes == Sizes.Medium && tw`w-24 h-24`,
  sizes == Sizes.Large && tw`w-36 h-36`,
  sizes == Sizes.ExtraSmall && tw`w-6 h-6`,
])

export default function Spinner({ sizes, color }: SpinnerProps) {
  return (
    <StyledSpinner sizes={sizes}>
      <Rotating color={color} />
    </StyledSpinner>
  )
}
